import {ProductSwiper} from '../../../common/ui/ProductSwiper';
import {fetchTracked} from "../../catalog/infrastructure/CatalogService";

export const TrackedProductsSwiper = () => {
  return (
    <ProductSwiper title={'PRODUCTOS PENDIENTES'} fetchFn={fetchTracked} />
  );
};
